<template>
  <div id="overlay" />
  <div id="promptTarget" />
  <div id="imageEnlargedTarget" class="relative z-image" />
  <div id="mapEnlargedTarget" />

  <notifications>
    <tasks>
      <header-provider>
        <prompt-provider>
          <public-layout v-if="match.meta.layout === 'public' || !loggedIn">
            <router-view />
          </public-layout>
          <dashboard-layout v-else>
            <router-view />
          </dashboard-layout>
        </prompt-provider>
      </header-provider>
    </tasks>
  </notifications>
</template>

<script setup>
import DashboardLayout from '@components/layouts/Dashboard.vue';
import PublicLayout from '@components/layouts/Public.vue';
import Notifications from '@components/utils/notifications/Notifications.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PromptProvider from '@utils/prompt/PromptProvider.vue';
import { useStore } from '@/store';
import HeaderProvider from './components/structure/navigation/HeaderProvider.vue';
import Tasks from './Tasks.vue';

const match = useRoute();
const store = useStore();

const loggedIn = computed(() => store?.state.auth.user && store?.state.auth.loggedIn);
</script>

<style lang="scss" scoped></style>
